import { MediaStage } from "@/core/types/mediaTypes";

/**
 * Sentinel meaning "every stage" for review mode. Kept out of the MediaStage
 * enum because it is a filter selector, not a real media stage.
 */
export const REVIEW_STAGE_ALL = "all" as const;

export type ReviewStage = MediaStage | typeof REVIEW_STAGE_ALL;

/**
 * Resolve the review-mode stage from the `stage` URL query param.
 *
 * Mirrors the library grid: `stage=all` shows every stage, any valid
 * MediaStage filters to that stage, anything else falls back to DRAFT.
 * The grid previously diverged here by coercing `all` to DRAFT, which hid
 * items in review mode.
 */
export function resolveReviewStage(stageParam: string | null): ReviewStage {
  if (stageParam === REVIEW_STAGE_ALL) {
    return REVIEW_STAGE_ALL;
  }
  if (
    stageParam &&
    Object.values(MediaStage).includes(stageParam as MediaStage)
  ) {
    return stageParam as MediaStage;
  }
  return MediaStage.DRAFT;
}
